export function getCalculatedSum ( price, qtty ) {
    if ( price ) {
        const result = price * qtty
        const formatedResult = String(result).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + ',00 р'
        return formatedResult;
    } else {
        return 'По запросу'
    }
}